module.exports = __webpack_public_path__ + "96247565bbe23eca7dd1faed1d8b1cbb.png";